import type { Component } from "vue";

export class ClubAdvantage {
	refName: string;
	cardTitleIcon: Component;
	title: string;
	isPopUpOpen: boolean;
	cardContent?: string;
	cardImage?: string;
	cardComponent?: Component;
	popUpComponent?: Component;
	constructor(
		refName: string,
		cardTitleIcon: Component,
		title: string,
		isPopUpOpen: boolean,
		cardContent?: string,
		cardImage?: string,
		cardComponent?: Component,
		popUpComponent?: Component
	) {
		this.refName = refName;
		this.cardTitleIcon = cardTitleIcon;
		this.title = title;
		this.isPopUpOpen = isPopUpOpen;
		this.cardContent = cardContent;
		this.cardImage = cardImage;
		this.cardComponent = cardComponent;
		this.popUpComponent = popUpComponent;
	}
}
